import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import animateScrollTo from 'animated-scroll-to'
import Symbols from '../../../common/assets/symbols'

const Poster = (props) => {
  const styles = {
    poster: {
      height: props.openPoster ? '37vw' : '0',
      transition: 'height .7s cubic-bezier(0.5, 0, 0.1, 1)',
    },
  }

  const handleOnTransitionEnd = (event) => {
    if (props.openPoster) {
      const options = {
        speed: 150,
      }

      animateScrollTo((event.currentTarget.offsetTop + event.currentTarget.getBoundingClientRect().height) - window.innerHeight, options)
    } else {
      props.setSelectedTitle(0)
    }
  }

  const skatersList = props.meta.skaters.map((skater, index, array) => {
    const trailingComma = index !== array.length - 1 ? ', ' : ''

    return (
      <React.Fragment key={index}>
        <Link className="poster__meta-link" to={`/browse/genre/${skater.id}`}>
          {`${skater.name}`}
        </Link>
        {`${trailingComma}`}
      </React.Fragment>
    )
  })

  const directorsList = props.meta.directors.map((director, index, array) => {
    const trailingComma = index !== array.length - 1 ? ', ' : ''

    return (
      <React.Fragment key={index}>
        <Link className="poster__meta-link" to={`/browse/genre/${director.id}`}>
          {`${director.name}`}
        </Link>
        {`${trailingComma}`}
      </React.Fragment>
    )
  })

  const brandsList = props.meta.brands.map((brand, index, array) => {
    const trailingComma = index !== array.length - 1 ? ', ' : ''

    return (
      <React.Fragment key={index}>
        <Link className="poster__meta-link" to={`/browse/genre/${brand.id}`}>
          {`${brand.name}`}
        </Link>
        {`${trailingComma}`}
      </React.Fragment>
    )
  })

  const genresList = props.meta.genres.map((genre, index, array) => {
    const trailingComma = index !== array.length - 1 ? ', ' : ''

    return (
      <React.Fragment key={index}>
        <Link className="poster__meta-link" to={`/browse/genre/${genre.id}`}>
          {`${genre.name}`}
        </Link>
        {`${trailingComma}`}
      </React.Fragment>
    )
  })

  return (
    <div className="poster" style={styles.poster} onTransitionEnd={handleOnTransitionEnd}>
      <div className="poster__background">
        <div className="poster__image" style={{ backgroundImage: `url("${props.artworkUrl}")`, }} />
        <div className="poster__gradient-overlay" />
      </div>
      <div className="poster__content">
        <h3 className="poster__title">{props.name}</h3>
        <div className="poster__overview">
          <div className="poster__specs">
            <span className="poster__spec-item">{props.meta.year}</span>
            <span className="poster__spec-item">{`${props.meta.duration} minutes`}</span>
          </div>
          <div className="poster__synopsis">{props.synopsis}</div>
          <div className="poster__meta">
            <p className="poster__meta-item">
              <span className="poster__meta-label">Skaters:</span>
              <span className="poster__meta-value">{skatersList}</span>
            </p>
            <p className="poster__meta-item">
              <span className="poster__meta-label">Directors:</span>
              <span className="poster__meta-value">{directorsList}</span>
            </p>
            <p className="poster__meta-item">
              <span className="poster__meta-label">Brands:</span>
              <span className="poster__meta-value">{brandsList}</span>
            </p>
            <p className="poster__meta-item">
              <span className="poster__meta-label">Genres:</span>
              <span className="poster__meta-value">{genresList}</span>
            </p>
          </div>
        </div>
        <Link className="poster__play-button" to={`/watch/${props.id}`}>
          <div className="poster__play-button-icon" />
        </Link>
      </div>
      <div className="poster__close-button" onClick={props.onPosterCloseClick}>
        <div className="poster__close-button-icon">{Symbols.close}</div>
      </div>
    </div>
  )
}

Poster.propTypes = {
  imageUrl: PropTypes.string,
  onPosterCloseClick: PropTypes.func,
  openPoster: PropTypes.bool,
  setSelectedTitle: PropTypes.func,
  titles: PropTypes.array,
}

Poster.defaultProps = {
  imageUrl: "http://prototype.5forty.com/sample/posters/006.jpg",
  openPoster: false,
}

export default Poster



// WEBPACK FOOTER //
// ./src/desktop/components/poster/index.js